import { BreakpointObserver, Breakpoints, MediaMatcher } from '@angular/cdk/layout';
import { AfterContentInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BusListener, LibAuthService, LibBusService, LibListenerAllAction, LibMenu, LibMenuService, LibMessageBusListener } from 'ngx-mat-base-comp';
import packageInfo from 'package.json';
import { Subscription, filter, map, mergeMap } from 'rxjs';
import { listMenu } from 'src/app/shared/menu/menu-items';
import { environment } from 'src/environments/environment';
import { LibAuthService as MatAuthService } from 'ngx-mat-auth';
import { EntityService } from 'src/app/modules/entity/entity.service';

@BusListener(LibMessageBusListener.Main)
@Component({
  selector: 'app-main-layout',
  templateUrl: 'main.component.html',
  styleUrls: ['main.component.scss']
})
export class MainComponent implements OnDestroy, AfterContentInit {

  @ViewChild('snav') snav!:  MatSidenav

  buildVersion = packageInfo.version
  envName = environment.name;
  sidebarOpened: any = false;
  mobileQuery: MediaQueryList;
  isBigScreen = false;
  icon = 'menu_open';
  url: any = '';
  isHelpEnabled = false;// this.envName !== 'prod';
  isNotificationEnabled = false;
  urlWikisite = ''
  menuItems: LibMenu[] = [];
  showSideNav = true;

  private subs = new Subscription();
  
  constructor(
    private media: MediaMatcher,
    private libBusService: LibBusService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private menuService: LibMenuService,
    private libAuthService: LibAuthService,
    private libMatAuthService: MatAuthService,
    private entityService: EntityService,
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 1024px)');
    this.isBigScreen = !media.matchMedia('(max-width: 1919px)').matches;
    this.libBusService.isBigScreen = this.isBigScreen;

    this.subs.add(breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge
    ]).subscribe(result => {
      if (result.matches) {
        this.sendLayoutSizeChangedMessage();
      }
    }));
    
    // Url Route
    this.subs.add(this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter(route => route.outlet === 'primary'))
      .pipe(mergeMap(route => route.data))
      .subscribe(event => {
        this.url = event;
      }));

      this.subs.add(this.entityService.list(false, 'settings/list').subscribe(resp => {
        EntityService.appSettings = resp;
      }));
  }
  async ngAfterContentInit(): Promise<void> {
    const menuItems = listMenu.find(x => x.module === this.libBusService.module);
    this.menuItems =  menuItems?.items ? this.menuService.getAuthorizedMenus(menuItems.items) : [];

    const menuMainModule = listMenu.find(x => x.module === "");
    const menuMainModuleAuthorizedItems = menuMainModule?.items ? this.menuService.getAuthorizedMenus(menuMainModule?.items?.filter(x => x.state !== '') || []) : [];

    if (this.menuItems.length === 0) {
      
      this.libAuthService.unauthorizedUser();

    } else if (this.libBusService.module === '' && menuMainModuleAuthorizedItems?.length === 1) { //if has access only to 1 module redirect to module.

      this.getUser();
      this.router.navigate([`/${menuMainModuleAuthorizedItems[0].state}`]);

    } else if (this.libBusService.module !== '' && menuMainModuleAuthorizedItems?.length === 1) {
      this.getUser();
      this.menuItems = this.menuItems.filter(x => x.icon !== 'arrow_back') // remove option back to menu if has access only to 1 module
    } else {
      this.getUser();
    }
  }

  getUser(){
    this.libMatAuthService.getCurrentUserInfo().then((user: any) => {
      if (user) {
        const firstName = user.attributes?.given_name ?? user.username;
        const lastName = user.attributes?.family_name ?? '';
        this.libBusService.user = {
          firstName: firstName,
          lastName:lastName, 
          username: user.username ?? '', 
          name: `${firstName} ${lastName}`};
      }
    })
  }

  sendLayoutSizeChangedMessage(): void {
    this.isBigScreen = !this.media.matchMedia('(max-width: 1919px)').matches;
    this.libBusService.isBigScreen = this.isBigScreen;
    this.libBusService.sendMessageToAll(LibListenerAllAction.LayoutSizeChanged);
  }

  sidebarToggle(): void {
    if (this.snav) {
      this.snav.toggle();
    }
    if (this.icon === 'menu_open') {
      this.icon = 'menu';
    } else {
        this.icon = 'menu_open';
    }
  }


  _newRelease(data: any) {
    this.showSideNav = data.showSideMenu;
  }


  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
